// shared.module.ts
import { NgModule } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { HttpClient } from "@angular/common/http";
import { TranslationLoadedService } from "../services/translation-loaded.service";
import { CommonModule } from '@angular/common';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }

  const lang = TranslationLoadedService.prototype.defaultLanguage$ ?? 'es'; 

  console.log('INgreso en idioma',lang);

@NgModule({
  imports: [
    CommonModule, 
  ],
  exports: [
    CommonModule,
    TranslateModule
  ]
})
export class SharedModule { }
